'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ti = require('react-icons/lib/ti');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PickupLocatorDistance = function PickupLocatorDistance(props) {
  return _react2.default.createElement(
    'div',
    { styleName: 'container' },
    _react2.default.createElement(
      'div',
      { styleName: 'marker' },
      props.selected ? _react2.default.createElement(_ti.TiLocation, null) : _react2.default.createElement(_ti.TiLocationOutline, null)
    ),
    _react2.default.createElement(
      'div',
      null,
      props.distance,
      ' mil'
    )
  );
};

exports.default = (0, _reactCssModules2.default)(PickupLocatorDistance, _style2.default);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/PickupLocator/Distance/index.js
// module id = 598
// module chunks = 0